export const AppStatus = {
    INITIALIZE: 0,
    INITIALIZED: 1,
    STARTED: 2,
    ERROR: 5
}

export const AppViews = {
    MAIN: 0,
    ERROR: 5
}

export const ViewStatus = {
    VIEW_INIT: 0,    
    VIEW_INITIALIZED: 1,
    SURVEY_ERROR: 5,
    ERROR: 8
}

export const ModalTypes = {
    CREDENTIALSPAGE: {
        customStyles: ""
    },
    LOGGEDPAGE:{
        customsStyles:""
    }
}

export const FormTypes = {
    LOGIN: 0,
    LOGGED: 1,
    RECOVERY: 2
}


export const ErrorCodes = {
    0: "ErrorCode0",
    1: "ErrorCode1",
    2: "ErrorCode2",
    3: "ErrorCode3",
    4: "ErrorCode4",
    5: "ErrorCode5",
    6: "ErrorCode6",
 
}